<template>
  <div class="order">
    <fm-head title="点歌"><span class="beta">beta</span></fm-head>
    <div class="form">
      <van-cell-group :border="false">
        <van-field
          v-model="songName"
          required
          clearable
          label="歌名"
          placeholder="请输入歌名"
        />

        <van-field
          v-model="singerName"
          required
          clearable
          label="歌手"
          placeholder="请输入歌手"
        />

        <van-field
          v-model="nickname"
          required
          clearable
          label="花名"
          placeholder="请输入花名（管理员联系用）"
        />

        <van-field
          v-model="message"
          label="留言"
          type="textarea"
          placeholder="请输入留言"
          rows="2"
          autosize
        />

        <van-cell
          v-if="false"
          title="是否对外匿名"
          label=""
          required
        >
          <van-switch
            v-model="checked"
            size="24px"
          />
        </van-cell>

        <van-field
          v-if="!isFromAdmin"
          label="日期"
          :value="showDateText"
          required
          readonly
          :is-link="true"
          @click="showPopup"
        ></van-field>
      </van-cell-group>

      <div v-if="!isFromAdmin" class="num-tips">{{ orderedNumberText }}</div>

      <van-button
        class="form__btn"
        type="primary"
        size="large"
        @click="createOrder"
      >提交</van-button>
    </div>

    <van-popup
      v-model="datePickerShow"
      position="bottom"
    >
      <van-datetime-picker
        v-model="date"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        :show-toolbar="true"
        @confirm="onDatePickerConfirm"
        @cancel="hideDatePicker"
      />
    </van-popup>

    <copyright></copyright>
  </div>
</template>

<script>
import { CellGroup, Field, Cell, Switch, Icon, Button, Popup, DatetimePicker } from 'vant'
import Head from '@/components/Head'
import Copyright from '@/components/Copyright'
import api from '@/api'
import { verifyHuaming } from '@/utils'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn' // 按需加载
import calendar from 'dayjs/plugin/calendar'
dayjs.locale('zh-cn')
dayjs.extend(calendar)

export default {
  name: 'Order',
  components: {
    'fm-head': Head,
    'copyright': Copyright,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
  },
  data () {
    return {
      songName: '',
      singerName: '',
      nickname: '',
      message: '',
      // checked: true,
      datePickerShow: false,
      date: null,
      orderedNumber: 0,
      orderCount: 0,
      fields: [
        {
          key: 'songName',
          label: '歌名',
          placeholder: '请输入歌名',
          errMsg: '歌名不能为空'
        },
        {
          key: 'singerName',
          label: '歌名',
          placeholder: '请输入歌名',
          errMsg: '歌名不能为空'
        },
        {
          key: 'nickname',
          label: '歌名',
          placeholder: '请输入歌名',
          errMsg: '歌名不能为空'
        },
        {
          key: 'message',
          label: '歌名',
          placeholder: '请输入歌名',
          errMsg: '歌名不能为空'
        },
        {
          key: 'date',
          label: '歌名',
          placeholder: '请输入歌名',
          errMsg: '歌名不能为空'
        },
      ],
      flag: true
    }
  },
  computed: {
    isFromAdmin() {
      return this.$route.query.from === 'admin'
    },
    showDateText() {
      let res = '请选择日期'
      if (this.date) {
        res = dayjs(this.date).calendar(null, {
          sameDay: '[今天]', // 今天
          nextDay: '[明天]', // 明天
          // nextWeek: '[下]dddd', // 下周
          nextWeek: 'YYYY-MM-DD', // 下周
          sameElse: 'YYYY-MM-DD' // 其他情况 ( 7/10/2011 )
        })
        const weekdayText = '日_一_二_三_四_五_六'.split('_')
        const d = dayjs(this.date).get('day')
        const weekday = ` 星期${weekdayText[d]}`
        res += weekday
      }
      return res
    },
    minDate() {
      const hour = new Date().getHours()
      let diffDay = 0
      if (hour >= 12) {
        diffDay = 1
      }
      return dayjs().add(diffDay, 'day').toDate()
    },
    maxDate() {
      const weekday = new Date().getDay()
      let diffDay = 0
      if (weekday >= 5) {
        diffDay = 8 - weekday
      } else {
        diffDay = 1
      }
      return dayjs().add(diffDay, 'day').toDate()
    },
    orderedNumberText() {
      const { orderedNumber } = this
      if (orderedNumber === 0) {
        return `怎么没人点歌呢？`
      } else if (orderedNumber > 0 && orderedNumber < 3) {
        return `还有名额哦`
      } else if (orderedNumber >= 3) {
        return `当日名额抢完啦，明天再来吧~`
      }
    }
  },
  methods: {
    showPopup() {
      this.datePickerShow = true
    },
    onDatePickerConfirm(value) {
      this.date = value
      console.log(value)
      this.datePickerShow = false
      const dateRange = [dayjs(this.date).format('YYYY-MM-DD').toString()]
      this.getList(dateRange)
    },
    hideDatePicker() {
      this.datePickerShow = false
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      }
      return value
    },
    async createOrder() {
      const date = this.date

      if (!this.songName) {
        this.$toast('歌名不能为空')
        return false
      }
      if (!this.singerName) {
        this.$toast('歌手不能为空')
        return false
      }
      if (!this.nickname) {
        this.$toast('花名不能为空')
        return false
      }
      if (!verifyHuaming(this.nickname)) {
        this.$toast('请填写正确的花名')
        return false
      }
      // if (this.message.length > 40) {
      //   this.$toast('')
      //   return false
      // }
      if (!this.date) {
        this.$toast('请选择歌曲播放日期')
        return false
      }
      if (this.orderCount >= 3) {
        this.$toast('够了，你已经点了3首了！')
        return false
      }

      if (!this.flag) {
        return false
      }
      this.flag = false
      const res = await api.createOrder({
        songName: this.songName,
        singerName: this.singerName,
        nickname: this.nickname,
        date: this.date,
        message: this.message
      })
      console.log(res)
      if (res.code === 0) {
        this.$toast('哦了')
        this.orderCount += 1
        this.resetData()
      } else {
        this.$toast(res.message)
      }
      this.flag = true

      if (!this.isFromAdmin) {
        const dateRange = [dayjs(date).format('YYYY-MM-DD').toString()]
        this.getList(dateRange, () => {
          if (this.orderedNumber > 3) {
            this.$toast(`慢了一步，目前排在第${this.orderedNumber}首`)
          }
        })
      }
    },
    resetData() {
      this.songName = ''
      this.singerName = ''
      this.nickname = ''
      this.date = this.$route.query.date || null
      this.message = ''
    },
    async getSongCommentList() {
      const res = await api.getSongCommentList()
      console.log(res)
    },
    async getList(dateRange, cb) {
      const res = await api.getOrderList(dateRange)
      if (res.code === 0) {
        console.log(res.data.list.length)
        this.orderedNumber = res.data.list.length

        cb && cb()
      } else {
        this.$toast(res.message)
      }
    }
  },
  created() {
    const { date, from } = this.$route.query
    if (from === 'admin') {
      this.date = date
    } else {
      const hour = new Date().getHours()
      let diffDay = 0
      if (hour >= 12) {
        diffDay = 1
      }
      this.date = dayjs().add(diffDay, 'day').toDate()
      const dateRange = [dayjs(this.date).format('YYYY-MM-DD').toString()]
      this.getList(dateRange)
    }
    // this.getSongCommentList()
  }
}
</script>

<style lang="less" scoped>
.order {
  min-height: 100vh;
  background: #fff;
}
.form {
  // margin-top: 20px;
  padding: 0 20px;
  border-top: 1px solid #f1f1f1;
  &__btn {
    margin-top: 20px;
  }
}
.beta {
  margin-left: 10px;
  padding: 0 5px;
  height: 20px;
  border-radius: 10px 10px 10px 0;
  font-size: 14px;
  line-height: 20px;
  color: #fff;
  background: #aaa;
}
.num-tips {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderSong/index.vue